module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--huge@2x-a3fcc02f0e3326f2ec1f9cf89477b41a.jpg";